import { useTheme } from "styled-components";
import { Flex } from "waapi/waap-ui/components/Flex/Flex.js";
import { Text } from "waapi/waap-ui/components/Text/Text.js";
import { TextSize, TextWeight } from "waapi/waap-ui/components/Text/Text.types.js";
import { getCrossSellProductsConfig } from "../../helpers/getCrossSellProductsConfig.js";
import { useTranslation } from "../../hooks/useTranslation/hook.js";
import { DropdownHeader, ProductContainer, ProductLogoContainer } from "./CrossSellDropdown.styles.js";

export const CrossSellDropdown = () => {
    const { t, translations } = useTranslation();
    const theme = useTheme();

    const crossSellProductsConfig = getCrossSellProductsConfig({ t, translations });

    return (
        <Flex direction="column" width="300px">
            <DropdownHeader>
                <Text color={theme.grayscale[80]} size={TextSize["X-SMALL"]}>
                    {t(translations.cross_sell.discover())}
                </Text>
            </DropdownHeader>
            {crossSellProductsConfig.map(({ title, description, icon, iconBackgroundColor, link }) => (
                <ProductContainer key={title} direction="row" gap="16" align="start" onClick={() => window.open(link)}>
                    <ProductLogoContainer justify="center" align="center" backgroundColor={iconBackgroundColor}>
                        <img src={icon} alt={`${title}-logo`} />
                    </ProductLogoContainer>
                    <Flex direction="column" gap="4" align="start">
                        <Text color={theme.grayscale[100]} size={TextSize.SMALL} weight={TextWeight.SEMIBOLD}>
                            {title}
                        </Text>
                        <Text color={theme.grayscale[90]} size={TextSize["X-SMALL"]}>
                            {description}
                        </Text>
                    </Flex>
                </ProductContainer>
            ))}
        </Flex>
    );
};
